import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {Provider} from "react-redux";
import store from "./store/store";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {config} from "./config";
import {User} from "./components/user";
import SideBar from "./components/SideBar";
import {Profile} from "./components/user/Profile";
import {MyTeam} from "./components/user/MyTeam";
import {MyTeamActivity} from "./components/user/MyTeamActivity";
import {ManageLeads} from "./components/user/ManageLeads";
import {Favorties} from "./components/user/Favourite";
import {Notifications} from "./components/user/Notification";
import {RoutesPage} from "./components/user/Routes";
import Reminders from "./components/Reminders";
import {ManageNotifications} from "./components/user/ManageNotification";
import {ToastProvider} from "@radix-ui/react-toast";
import {PostMail} from "./components/user/PostMail";
import Login from "./components/Login";
import {ProtectedRoute} from "./components/ProtectedRoute";
import Register from "./components/Register";

const router = createBrowserRouter([
    {
        path: "/",
        element: <App/>,
    },
    {
        path: "/login",
        element: <Login/>,
    },
    {
        path: "/register",
        element: <Register/>,
    },
    {
        path: config.path + "accept-invite/:token",
        element: <Register/>,
    },
    {
        element: <ProtectedRoute/>,
        children: [
            {
                path: config.path,
                element: <App/>,
                children: [
                    {
                        index: true,
                        element: <SideBar/>,
                    },
                    {
                        path: "accept-invite/:token",
                        element: <SideBar/>,
                    },
                    {
                        path: "/:listingId",
                        lazy: () => import("./components/ListingDetails"),
                    },
                    {
                        path: "add-listing",
                        lazy: () => import("./components/AddingListing"),
                    },
                    {
                        path: "edit-listing/:listingId",
                        lazy: () => import("./components/EditListing"),
                    },
                    {
                        path: "profile",
                        element: <Profile/>,
                    },
                    {
                        path: "my-team",
                        element: <MyTeam/>,
                    },
                    {
                        path: "my-team-activity",
                        element: <MyTeamActivity/>,
                    },
                    {
                        path: "manage-leads",
                        element: <ManageLeads/>,
                    },
                    {
                        path: "favourites",
                        element: <Favorties/>,
                    },
                    {
                        path: "notifications",
                        element: <Notifications/>,
                    },
                    {
                        path: "routes",
                        element: <RoutesPage/>,
                    },
                    {
                        path: "team-routes",
                        element: <RoutesPage isTeamRoutes={true}/>,
                    },
                    {
                        path: "reminders",
                        element: <Reminders/>,
                    },
                    {
                        path: "manage-notification",
                        element: <ManageNotifications/>,
                    },
                    {
                        path: "post-mail",
                        element: <PostMail/>,
                    },
                ],
            },
            {
                path: config.path + "commercial",
                element: <App/>,
                children: [
                    {
                        index: true,
                        element: <SideBar/>,
                    },
                    {
                        path: ":listingId",
                        lazy: () => import("./components/ListingDetails"),
                    },
                ],
            },
        ],
    },

    {
        path: config.path + "listing/:listingId",
        element: <App/>,
    },
    {
        path: config.path + "user",
        element: <User/>,
    } /*,
    {
        path: config.path + "route/:routeId",
        element: <App/>,
    }*/,
]);

async function enableMocking() {
    if (process.env.NODE_ENV !== "development") {
        return;
    }

    const {worker} = await import("./mocks/browser");

    // `worker.start()` returns a Promise that resolves
    // once the Service Worker is up and ready to intercept requests.
    // return worker.start();
}

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
enableMocking().then(() => {
    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <ToastProvider>
                    <RouterProvider router={router}/>
                </ToastProvider>
            </Provider>
        </React.StrictMode>
    );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
